module.exports = __webpack_public_path__ + "img/mapCamera0.8b4d7e4f.png";